// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Row, Col,Label,Button, ListGroup, ListGroupItem, Table } from "reactstrap";
import TableWithSortPagtn from "../../common/TableForLeavesTakenReport";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import api from "../../../apis/api";
import Notifications from "../../common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components"; 
import "../../../style/report.css";

const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let estimated=0;
let maxwidth="80vw";
const ListleavestakenReport = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handlereload,
    disablePagination = false
  }) => {
    const [thead] = useState([
      "Type",
      "Applied Date",
      "Date From",
      "Date To",
      "Status",
      "Day(s)",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   const [curstatus,setcurstatus] =useState(0);
   const [curstatusList,setcurstatusList] = useState([]);
   const [reason,setreason] = useState("");
   const [error, setError] = useState(null);
   const [loaded, setLoaded] = useState(false);
   
   const DarkBackground = styled.div`
   display: none; /* Hidden by default */
     position: fixed; /* Stay in place */
     z-index: 999; /* Sit on top */
     left: 0;
     top: 0;
     width: 100%; /* Full width */
     height: 100%; /* Full height */
     overflow: auto; /* Enable scroll if needed */
     background-color: rgb(0, 0, 0); /* Fallback color */
     background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
   ${(props) =>
     props.disappear &&
     css`
       display: block; /* show */
     `}
   `;
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);


    const chunkSize = 30;
    const breakStringIntoChunks = (str, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < str.length; i += chunkSize) {
        chunks.push(str.substring(i, i + chunkSize));
      }
      return chunks;
    };
    // useEffect(() => {
    //   sumhours=0;
    //   sumbillable=0;
    //   estimated=0;
    //   empTask.map((el) =>{
    //     sumhours = sumhours+el.hoursSpent;
    //     sumbillable =sumbillable+el.hoursBillable;
    //     estimated=estimated+el.estimatedHour;
    //   });
    //   let trow = empTask.map((el) => ({
    //     Date:<div style={{width:'100px'}}>{moment(el.workDate).format('DD-MM-YYYY')}</div>,
    //     Project: <div style={{width:'100px'}}>{el.projectName === null ? "" : el.projectName}</div>,
    //     Employee: (
    //      <div style={{width:'140px'}}><h2 className="table-avatar">

    //         <span className="ml-2">
    //           <span style={{ fontWeight: "400", color: "black" }}>
    //             {el.employeeName}
    //           </span>
    //           {/* <span> {el.empDesignation}</span> */}
    //         </span>
    //       </h2></div>
    //     ),
    //     Task: <div style={{width:'100px'}}>{el.issueTitle === null ? "" : el.issueTitle}</div>,
    //     Description:el.description === null ?"" : (breakStringIntoChunks(el.description, chunkSize).map((chunk, chunkIndex) => (
    //       <div key={chunkIndex} style={{width:'230px'}}>{chunk}</div>))),
    //     "Estimated Hours":<div style={{width:'50px'}}>{el.estimatedHour}</div>,
    //     "Hours Spent": <div style={{width:'120px'}}>{el.hoursSpent === null ? "" : el.hoursSpent}</div>,
    //     "Hours Billable": <div style={{width:'120px'}}>{el.hoursBillable === null ? "" : el.hoursBillable}</div>,
    //     // "Leave Type": <div>{el.leaveType==1 ? "Half Day":(el.leaveType==2 ? "Full Day" : "Full Day")}</div>,
    //     Status: <div style={{width:'100px'}}>{el.timeSheetStatus==1 ? "New" : (el.timeSheetStatus==2 ? "In Progress" : "Completed")}</div>,
       
        

    //     // requester: <span style={{ fontSize: "12px " }}>{el.employeeName}</span>,
    //     // action: (
    //     //   <DropDownActions
    //     //     dropDownOption={[
    //     //       {
    //     //         action: "Edit",
    //     //         handleAction: () => handleClickTicket(el),
    //     //       },
    //     //       {
    //     //         action: "View",
    //     //         handleAction: () => handleClickDelete(el.ticketId),
    //     //       },
    //     //     ]}
    //     //   ></DropDownActions>
    //     // ),
    //     // requester: el.requesters.map((el) => (
    //     //   <span style={{ fontSize: "12px " }}>{el.employeeName},</span>
    //     // )),
    //   }));
    //   console.log(trow);
    //   setTrow(trow);
    // }, []);
    const onchangeApprovestatus=React.useCallback((val) =>{
      // let formData = {};
      // const ids = empTask.map(user => user.timesheetStatusId);
      // const joinedString=ids.join(',');
      // formData = {
      
      //   employeeTimeSheetIdList:joinedString,
      //   approvedStatus:true,
      //   approvedId:parseInt(loginUser.EmployeeId),        
      //   reason:""
      // };
      // await api.task().ApproveTaskStatus(formData);
      setcurstatus(val);
      setcurstatusList({value : val ,label : val==1 ? "Approve" :"Rejected"})
    },[setcurstatus,setcurstatusList]);
    const handleChange =(reason) =>{
      setreason(reason.target.value);
    }
    const handleSubmit=React.useCallback( async () => {
      setLoaded(true);
      let formData = {};
      const ids = empTask.map(user => user.timesheetStatusId);
      const joinedString=ids.join(',');
      formData = {
      
        employeeTimeSheetIdList:joinedString,
        approvedStatus:curstatus==1 ? true :false,
        approvedId:parseInt(loginUser.EmployeeId),        
        reason:reason
      };

      if(curstatus == 1)
        {
          setcurstatusList([]);
          setreason("");
          setcurstatus(0);
          await api.task().ApproveTaskStatus(formData);
          setError({ ...error, message: "Work Status Approved Successfully..", status: 200 });
          // setError({ ...error, message: "Work Status Approved Successfully..", status: 200 });
        }
        else if(curstatus == 2)
        {
          if(reason != '')
          {
            setcurstatusList([]);
            setreason("");
            setcurstatus(0);
          await api.task().ApproveTaskStatus(formData);
          setError({ ...error, message: "Work Status Rejected Successfully..", status: 200 });
          }
          // setError({ ...error, message: "Work Status Rejected Successfully..", status: 200 });
        }
        else
        {
          setError({ ...error, message: "Choose approve/reject..", status: 500 });
        }
        handlereload(curstatus,reason);
    //  setTimeout(() => { 
   
          
    //   }, 3000);
     
    },[setcurstatusList,setreason,setcurstatus,empTask,loginUser,curstatus,reason])
    return (
      <Fragment>

          <div>
            {empTask.map((el) =>
              <div className="reportbox" style={{ height: 'auto', minHeight: '100px', marginBottom: '20px', padding: '15px' }}>
              <Row>
                <Col md={4}>
                <div className="leftdetails">
                    <Row>
                    <Label>Employee ID : </Label>
                    <Label>{el.employeeCode}</Label>
                    </Row>
                    <Row>
                    <Label>Employee Name : </Label>
                    <Label>{el.employeeName}</Label>
                    </Row>
                    <Row>
                    <Label>Location : </Label>
                    <Label>{el.address}</Label>
                    </Row>
                    <Row>
                    <Label>Report To : </Label>
                    <Label>{el.reportingManager}</Label>
                    </Row>
                 </div>
                </Col>
                <Col md={8}> 
                <div className="leftdetails">
                      <Table striped style={{ tableLayout: 'fixed' }}>
                       <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
                          <th style={{padding:'.25rem'}}>Type</th>
                          <th style={{padding:'.25rem'}}>Applied Date</th>
                          <th style={{padding:'.25rem'}}>Date From</th>
                          <th style={{padding:'.25rem'}}>Date To</th>
                          <th style={{padding:'.25rem'}}>Status</th>
                          <th style={{padding:'.25rem'}}>Day(s)</th>
                       </thead>
                      </Table>
                      <div style={{ 
                        maxHeight: disablePagination ? 'auto !important' : '300px', 
                        overflowY: disablePagination ? 'visible !important' : 'auto', 
                        overflowX: 'hidden',
                        width: '100%'
                      }}>
                      <Table striped style={{ tableLayout: 'fixed', marginBottom: 0 }}>
                       <tbody>
                         
                         {el.leaves.map((eln) =>{
                           return (
                          <tr>
                          <td style={{padding:'.25rem'}}>{eln.isAuto == true && eln.leaveType === "Loss Of Pay(LOP)" ? "Auto LOP" : eln.leaveType}</td>
                          <td style={{padding:'.25rem'}}>{moment(eln.appliedDate).format("DD-MM-YYYY")}</td>
                          <td style={{padding:'.25rem'}}>{moment(eln.leaveFromDate).format("DD-MM-YYYY")}</td>
                          <td style={{padding:'.25rem'}}>{moment(eln.leaveToDate).format("DD-MM-YYYY")}</td>
                          <td style={{padding:'.25rem'}}>{eln.leaveStatus}</td>
                          <td style={{padding:'.25rem'}}>{eln.totalLeave}</td>
                          </tr>
                           )
                         })} 
                        
                        </tbody>
                      </Table>
                      </div>
              
                 </div>
                </Col>
              </Row>



                  </div>  
     
            )}
                
           
          </div>
  
        
    <Notifications notifications={error}></Notifications>
    <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
        {/* <div className="mt-3">
          <ListGroup className="task-list ">
            {empTask.map((tasks, i) => (
              <ListGroupItem
                key={i}
                onClick={() => handleOnclickSelectedTask(tasks, i)}
                style={i === activeTask ? active : null}
              >
                <div className="task-container ">
                  <span className="task-check">
                  {tasks.timeSheetStatus ==3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green'}}></i>) : <i className="fas fa-check  project-task-icon"></i>}
                    
                  </span>
                  <span className="task-label">{tasks.description}</span>
                  <span className="task-label">{tasks.hoursSpent}</span>
                  <span className="task-label">{tasks.timeSheetStatus}</span>
                  <span className="task-action-btn task-btn-right">
                    <span
                      className="action-circle large task-assign"
                      title="Assign"
                    >
                      <i className="fas fa-user  project-task-icon"></i>
                    </span>
                    <span
                      className="action-circle large delete-btn"
                      title="Delete Task"
                      onClick={() => DelTask(tasks.employeeTimeSheetId)}
                    >
                      <i className="fas fa-trash project-task-icon"></i>
                    </span>
                  </span>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div> */}
      </Fragment>
    );
  }
);
export default ListleavestakenReport;
